import { render, staticRenderFns } from "./BuildingsCreatedChart.vue?vue&type=template&id=2902c715&scoped=true&"
import script from "./BuildingsCreatedChart.vue?vue&type=script&lang=js&"
export * from "./BuildingsCreatedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2902c715",
  null
  
)

export default component.exports